import type { ApiKey } from '@column/api';

export type APIKey = ApiKey;

// Keeps every visible key on an override, explicitly set to 'default' when unset: the backend's generated request
// types declare these fields required, so omitting one that's still 'default' fails validation. Overrides with no
// non-default key are dropped entirely, since they represent no actual override.
export const setDefaultOverrides = <T extends object>(
  overrides: T[] | undefined,
  idKey: keyof T,
  visibleKeys: readonly string[]
): T[] =>
  (overrides ?? [])
    .filter((override) => {
      const record = override as Record<string, unknown>;
      return visibleKeys.some((key) => (record[key] ?? 'default') !== 'default');
    })
    .map((override) => {
      const record = override as Record<string, unknown>;
      const filled: Record<string, unknown> = { [String(idKey)]: record[String(idKey)] };
      visibleKeys.forEach((key) => {
        filled[key] = record[key] ?? 'default';
      });
      return filled as T;
    });
